import React from "react"
import cx from "classnames"
import styled from "styled-components"
import ReactMarkdown from "react-markdown"
import { marginClasses } from "../util/cssClasses"

const Card = styled.div.attrs({
  className: "flex flex-col rounded-lg",
})``

const CardContent = styled.div.attrs({
  className: "p-m",
})``

export const FeaturesSectionRenderer = ({ data }) => {
  const features = data.features.map(f => (
    <Card key={f.id}>
      <div className="flex justify-center align-center pt-l text-blue-500">
        <img
          src={f.icon.localFile.publicURL}
          alt={"feature"}
          className={"w-xl"}
        />
      </div>
      <CardContent>
        <h3 className="heading-6 font-bold pb-s text-center">{f.title.text}</h3>
        <p className="text-center">
          <ReactMarkdown>{f.description.text}</ReactMarkdown>
        </p>
      </CardContent>
    </Card>
  ))
  return (
    <section
      className={cx(
        "flex flex-col items-center",
        marginClasses(data.margins, { marginBottom: "xl" })
      )}
    >
      <div className="grid grid-cols-2 md:grid-cols-4 w-full content-center gap-x-m md:gap-x-l gap-y-m mt-l md:mt-xl">
        {features}
      </div>
    </section>
  )
}
